<template>
  <div>
    <div class="form-group form-row">
      <label :for="safeId('overlayFileName')" class="col-sm-4 col-form-label">Template</label>
      <div class="col-sm-8">
        <input type="text" readonly class="form-control-plaintext" :id="safeId('overlayFileName')"
               v-model="overlayFileName">
      </div>
    </div>
    <div class="form-group form-row">
      <label :for="safeId('layer')" class="col-sm-4 col-form-label">Layer</label>
      <div class="col-sm-8">
        <input type="number" min="0" max="4294967295" class="form-control" :id="safeId('layer')" v-model.number="layer">
      </div>
    </div>

    <div class="form-group form-row" v-if="hasCustomPosition">
      <label :for="safeId('cssLeftValue')" class="col-sm-4 col-form-label">Left</label>
      <div class="col-sm-5">
        <input type="number" class="form-control" :id="safeId('cssLeftValue')" v-model.number="cssLeftValue">
      </div>
      <div class="col-sm-3">
        <b-form-select :id="safeId('cssLeftUnit')" v-model="cssLeftUnit" :options="unitOptionsLeftRight"></b-form-select>
      </div>
    </div>
    <div class="form-group form-row" v-if="hasCustomPosition">
      <label :for="safeId('cssTopValue')" class="col-sm-4 col-form-label">Top</label>
      <div class="col-sm-5">
        <input type="number" class="form-control" :id="safeId('cssTopValue')" v-model.number="cssTopValue">
      </div>
      <div class="col-sm-3">
        <b-form-select :id="safeId('cssTopUnit')" v-model="cssTopUnit" :options="unitOptionsTopBottom"></b-form-select>
      </div>
    </div>
    <div class="form-group form-row" v-if="hasCustomPosition">
      <label :for="safeId('cssRightValue')" class="col-sm-4 col-form-label">Right</label>
      <div class="col-sm-5">
        <input type="number" class="form-control" :id="safeId('cssRightValue')" v-model.number="cssRightValue">
      </div>
      <div class="col-sm-3">
        <b-form-select :id="safeId('cssRightUnit')" v-model="cssRightUnit" :options="unitOptionsLeftRight"></b-form-select>
      </div>
    </div>
    <div class="form-group form-row" v-if="hasCustomPosition">
      <label :for="safeId('cssBottomValue')" class="col-sm-4 col-form-label">Bottom</label>
      <div class="col-sm-5">
        <input type="number" class="form-control" :id="safeId('cssBottomValue')" v-model.number="cssBottomValue">
      </div>
      <div class="col-sm-3">
        <b-form-select :id="safeId('cssBottomUnit')" v-model="cssBottomUnit" :options="unitOptionsTopBottom"></b-form-select>
      </div>
    </div>


    <div class="form-group form-row" v-if="hasCustomColors">
      <label :for="safeId('color1')" class="col-sm-4 col-form-label">Color 1</label>
      <div class="col-sm-8">
        <b-form-select :id="safeId('color1')" v-model="color1" :options="colorOptions">
        </b-form-select>
      </div>
    </div>

    <div v-for="colorKey in colorKeys">
      <color-select-group :label="colorKey" v-model="colors[colorKey]"
                          @change="updateColors(colors)"></color-select-group>
    </div>

    <div class="form-group form-row" v-if="hasCustomColors">
      <label :for="safeId('color2')" class="col-sm-4 col-form-label">Color 2</label>
      <div class="col-sm-8">
        <b-form-select :id="safeId('color2')" v-model="color2" :options="colorOptions">
        </b-form-select>
      </div>
    </div>
    <div class="form-group form-row" v-if="hasCustomCss">
      <label :for="safeId('css')" class="col-sm-4 col-form-label">Custom CSS</label>
      <div class="col-sm-8">
        <textarea class="form-control" :id="safeId('css')" rows="5" v-model.lazy="css"></textarea>
      </div>
    </div>
    <div class="form-group form-row" v-if="hasCustomJson">
      <label :for="safeId('json')" class="col-sm-4 col-form-label">Custom JSON</label>
      <div class="col-sm-8">
        <textarea class="form-control" :id="safeId('json')" rows="5" v-model.lazy="customJsonString"></textarea>
      </div>
    </div>
    <album-select-group v-model="backgroundImageAlbumId" label="Background"></album-select-group>
    <picture-select-group v-model="backgroundImagePictureId" :album-id="backgroundImageAlbumId"
                          label="Image"></picture-select-group>
  </div>
</template>

<script>
  import * as action from '@/store/action-types'
  import { mapImageIdToImage, mapOverlayData, mapOverlayOptions, mapTemplateData } from '../../utils/index'

  export default {
    name: 'template-setting-overlay',
    props: {
      templateId: {
        type: String,
        required: true
      }
    },
    computed: {
      hasCustomBackgroundImage () {
        return this.$store.getters.template(this.templateId).options.customBackgroundImage
      },
      hasCustomColors () {
        return this.$store.getters.template(this.templateId).options.customColors === true
      },
      hasCustomCss () {
        return this.$store.getters.template(this.templateId).options.customCss
      },
      hasCustomJson () {
        return this.$store.getters.template(this.templateId).options.customJson
      },
      hasCustomPosition () {
        return this.$store.getters.template(this.templateId).options.customPosition
      },
      colorKeys () {
        const keys = this.$store.getters.template(this.templateId).options.customColors
        return Array.isArray(keys) ? keys : []
      },
      colorOptions () {
        return ['red', 'blue', 'white', 'black']
      },
      unitOptionsTopBottom () {
        return ['', 'px', 'vh', '%']
      },
      unitOptionsLeftRight () {
        return ['', 'px', 'vw', '%']
      },
      overlayFileName: {
        get: function () {
          return this.$store.getters.template(this.templateId).overlayFileName
        }
      },
      ...mapOverlayData({
        'css': {default: '.overlay {\n\n}'}
      }),
      ...mapOverlayOptions({
        'color1': {default: 'white'},
        'color2': {default: 'red'},
        'cssLeft': {default: ''},
        'cssTop': {default: ''},
        'cssRight': {default: ''},
        'cssBottom': {default: ''},
        'backgroundImage': {default: null},
        'position': {default: {}},
        'colors': {default: {}},
        'customJson': {default: {}}
      }),
      ...mapTemplateData(['backgroundImageAlbumId', 'backgroundImagePictureId']),
      layer: {
        get: function () {
          return this.$store.getters.template(this.templateId).layer || 0
        },
        set: function (val) {
          this.$store.dispatch(action.TEMPLATE_LAYER, {
            templateId: this.templateId,
            layer: val
          })
        }
      },
      customJsonString: {
        get: function () {
          return JSON.stringify(this.customJson, null, 2)
        },
        set: function (value) {
          try {
            this.customJson = JSON.parse(value)
          } catch (ex) {
            console.error('[studio/template-setting-overlay] Error parsing JSON: ', ex.message || ex)
          }
        }
      },
      cssTopValue: {
        get: function () {
          return this.cssTop.replace(/[^\d]/g, '')
        },
        set: function (value) {
          this.cssTop = value + this.cssTopUnit
        }
      },
      cssTopUnit: {
        get: function () {
          return this.cssTop.replace(/[\d]/g, '')
        },
        set: function (value) {
          this.cssTop = value === '' ? '' : this.cssTopValue + value
        }
      },
      cssBottomValue: {
        get: function () {
          return this.cssBottom.replace(/[^\d]/g, '')
        },
        set: function (value) {
          this.cssBottom = value + this.cssBottomUnit
        }
      },
      cssBottomUnit: {
        get: function () {
          return this.cssBottom.replace(/[\d]/g, '')
        },
        set: function (value) {
          this.cssBottom = value === '' ? '' : this.cssBottomValue + value
        }
      },
      cssLeftValue: {
        get: function () {
          return this.cssLeft.replace(/[^\d]/g, '')
        },
        set: function (value) {
          this.cssLeft = value + this.cssLeftUnit
        }
      },
      cssLeftUnit: {
        get: function () {
          return this.cssLeft.replace(/[\d]/g, '')
        },
        set: function (value) {
          this.cssLeft = value === '' ? '' : this.cssLeftValue + value
        }
      },
      cssRightValue: {
        get: function () {
          return this.cssRight.replace(/[^\d]/g, '')
        },
        set: function (value) {
          this.cssRight = value + this.cssRightUnit
        }
      },
      cssRightUnit: {
        get: function () {
          return this.cssRight.replace(/[\d]/g, '')
        },
        set: function (value) {
          this.cssRight = value === '' ? '' : this.cssRightValue + value
        }
      }
    },
    watch: {
      ...mapImageIdToImage('backgroundImageAlbumId', 'backgroundImagePictureId', 'backgroundImage')
    },
    methods: {
      updateColors () {
        this.colors = Object.assign({}, this.colors)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/template-settings/template-setting-overlay.vue